<template lang="pug">
    div#CodeEditorV3
        Spin(size="large" fix v-if="spinShow")
        Progress(:percent="uploadPercent" :stroke-width="20" status="active" text-inside v-if="spinShow")
        // Debug
        // Row
        //      Col(span="16")
        //          // Row
        //          //     pre {{ directoryTree | pretty }}
        //          // Row
        //          //     pre {{ focusTabId }}
        //          Row
        //              pre {{ editorTabs }}
        //      Col(span="8")
        //          // pre {{ value }}
        //          pre {{ autoCompleteList.length }}
        //          pre {{ autoCompleteList }}
        //      //     pre {{ preUploadFiles }}
        //      //     pre {{ uploadPercent }}
        //      //     pre {{ uploadFilesCount }} / {{ preUploadFiles.length }}
        Layout
            Header.editor-header
                Row.editor-header-toolbox
                    Dropdown(trigger="click" style="line-height: 1.5;" placement="bottom-start" @on-click="handleEditorFileMenuDropdown")
                        Button(size="small") File
                            Icon(type="ios-arrow-down")
                        template(slot="list")
                            DropdownMenu
                                Upload(
                                    v-if="allowUpload"
                                    :webkitdirectory="true"
                                    :multiple="true"
                                    :before-upload="beforeUpload"
                                    action="null"
                                    :show-upload-list="false"
                                    v-bind:with-credentials="true"
                                    style="line-height: 1.5;"
                                )
                                    DropdownItem Open Folder
                                DropdownItem(name="saveCode") Save File
                                DropdownItem(name="export" v-if="allowExport") Export Folder
                    Button(@click="prettifyCode" size="small") Prettify
                    Button(@click="toggleFullScreen" size="small") Fullscreen
            Layout
                Sider(style="min-height: 100vh; width: auto; max-width: unset; flex: 0 0 auto;")
                    vue-tree-list(
                        @click="onClickTreeNode"
                        @change-name="onChangeName"
                        @delete-node="onDel"
                        @add-node="onAddNode"
                        :model="directoryTree"
                        v-bind:default-expanded="false"
                        ref="tree"
                    )
                        template(v-slot:leafNameDisplay="slotProps")
                            span(:class="slotProps.model.id == focusTabId ? 'vtl-selected' : 'vtl-default'") {{ slotProps.model.name }}
                Layout
                    Content
                        Tabs(
                            :animated="false"
                            type="card"
                            closable
                            :before-remove="beforeTabRemove"
                            @on-tab-remove="handleTabRemove"
                            v-model="focusTabId"
                            @on-click="onClickTabs"
                        )
                            template(v-for="(tab,index) in editorTabs")
                                TabPane(
                                    :label="tab.hasEdited ? '[M] ' + tab.name : tab.name"
                                    :name="tab.id"
                                    :key="tab.id"
                                )
                                    CodeEditorV2(
                                        :ref="'CodeEditorV2-' + focusTabId"
                                        :value="tab.content"
                                        :formItem="formItem"
                                        @input="(...args) => { handleCodeChanged(tab.id, ...args) }"
                                        :cmOptionsInternal="cmOptionsInternal"
                                        :autoCompleteList="autoCompleteList"
                                    )
                    // Col(span="18" v-else)
                    //     h3 Select a file to edit
</template>
<script>
import CodeEditorV2 from "@/components/rcmTableFormItems/CodeEditorV2";
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
import dedent from "dedent";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import screenfull from "screenfull";
import bus from "@/libs/bus.js";

export default {
    name: "CodeEditorV3",
    props: {
        formItem: { type: Object },
        formData: { type: Object },
        value: { type: Array },
        allowExport: { type: Boolean, default: true },
        allowUpload: { type: Boolean, default: true },
    },
    components: {
        CodeEditorV2,
        VueTreeList,
    },
    data() {
        return {
            cmOptionsInternal: {
                extraKeys: {
                    "Ctrl-S": (instance) => {
                        this.saveCode(this.focusTabId);
                    },
                },
            },
            preUploadFiles: [],
            uploadFilesCount: 0,
            editorTabs: [],
            focusTabId: -1,
            directoryTree: { children: [], id: 0, isLeaf: false, name: "root", parent: null },
            maxFileQty: 2000,
            uploadTimer: null,
        };
    },
    async mounted() {
        this.updateDirectoryTree();
        var self = this;
        this.$nextTick(() => {
            if (this.value.length > 0) {
                self.editorDefaultOpenFile();
                self.$refs.tree.$children[0].toggle();
            }
        });
    },
    directives: {},
    methods: {
        handleEditorFileMenuDropdown(name) {
            switch (name) {
                case "saveCode":
                    this.saveCode(this.focusTabId);
                    break;
                case "export":
                    this.onExport();
                    break;
                default:
                    break;
            }
        },
        prettifyCode() {
            this.$refs["CodeEditorV2-" + this.focusTabId][0].prettifyCode();
        },
        toggleFullScreen() {
            const element = document.getElementById("CodeEditorV3");
            screenfull.toggle(element);
        },
        updateDirectoryTree() {
            this.directoryTree = this.createTreeStructureFromFiles(this.value);
        },
        onExport() {
            let files = this.value;
            let rootFolderName = files[0].path.split("/")[0];

            var zip = new JSZip();
            let createdFolders = {};
            files.forEach((file) => {
                // https://stuk.github.io/jszip/documentation/examples.html
                zip.file(file.path, file.content);
            });
            // zip.generateAsync({ type: "base64" }).then(function (content) {
            //     location.href = "data:application/zip;base64," + content;
            // });

            zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(content, rootFolderName + ".zip");
            });
        },
        // 改由前端上傳後渲染 (不須真的上傳到後台)
        // 兩階段: 先收集檔案, 後上傳
        beforeUpload(file) {
            this.preUploadFiles.push(file);

            // 這裡做debounce, 確定檔案都收集完後再一次解析檔案+上傳
            var self = this;
            clearTimeout(this.uploadTimer);
            this.uploadTimer = setTimeout(function () {
                self.readUploadFiles();
            }, 300);

            return false;
        },
        async readUploadFiles() {
            if (this.preUploadFiles.length > this.maxFileQty) {
                return this.$Modal.warning({
                    title: "Upload Failed",
                    content: `Upload ${this.preUploadFiles.length} exceeded than ${this.maxFileQty}`,
                    okText: `ok`,
                    onOk: () => {
                        this.resetUploadStatus();
                    },
                });
            }
            let files = await Promise.all(this.preUploadFiles.map((file) => this.readFile(file)));
            this.$emit("input", files);
            this.resetUploadStatus();
            var self = this;
            this.$nextTick(() => {
                self.editorDefaultOpenFile();
                self.$refs.tree.$children[0].toggle();
            });
        },
        // 接收file, 補上content
        readFile(file) {
            return new Promise((resolve, reject) => {
                var reader = new FileReader();
                if (file.type.indexOf("image/") >= 0) {
                    reader.readAsDataURL(file);
                } else {
                    reader.readAsText(file);
                }
                // reader.readAsBinaryString(file);
                var self = this;
                reader.onload = function () {
                    let content = "";
                    if (file.type.indexOf("image/") >= 0) {
                        content = reader.result.split("base64,")[1];
                    } else {
                        content = reader.result;
                    }
                    self.uploadFilesCount += 1;
                    // resolve(file);
                    let id = file.webkitRelativePath;
                    let path = file.webkitRelativePath;
                    let { lastModified, name, size, type, webkitRelativePath } = file;

                    resolve({
                        id,
                        path,
                        content,
                        lastModified,
                        name,
                        size,
                        type,
                        webkitRelativePath,
                    });
                };
            });
        },
        // 初始化時預設展開編輯檔案
        editorDefaultOpenFile() {
            let defaultOpenFile = this.value.find((e) => e.path.split("/").length == 2);
            if (defaultOpenFile) {
                let id = defaultOpenFile.path;
                let name = defaultOpenFile.path.split("/")[1];
                let content = defaultOpenFile.content;

                this.editorTabs = [{ id, name, content }];
                this.focusTabId = id;
            }
        },
        createTreeStructureFromFiles(files) {
            // console.log("re-create tree start");
            let rootTree = new Tree([]);

            files.forEach((file) => {
                let pathSplit = file.path.split("/");
                let currentPath = "";
                let currentNode = rootTree;

                pathSplit.forEach((currentPathSplit, i) => {
                    currentPath = pathSplit.slice(0, i + 1).join("/");
                    if (currentNode.children) {
                        let nextNode = currentNode.children.find((e) => e.id == currentPath);

                        // 找到繼續往下
                        if (nextNode) {
                            // console.log("find next node");
                            currentNode = nextNode;
                            return;
                        }
                    }

                    // 沒找到則創建節點
                    // console.log("no next node, create node");
                    // 若不是最後一個創建資料夾
                    if (i !== pathSplit.length - 1) {
                        currentNode.addChildren(
                            new TreeNode({ id: currentPath, name: currentPathSplit, isLeaf: false, children: [] })
                        );
                        // currentNode = currentNode.children;
                        currentNode = currentNode.children[currentNode.children.length - 1];
                        // 最後一個創建檔案
                    } else {
                        // 判斷是否為資料夾
                        if (file.content == undefined) {
                            currentNode.addChildren(
                                new TreeNode({ id: currentPath, name: currentPathSplit, isLeaf: false, children: [] })
                            );
                        } else {
                            currentNode.addChildren(
                                new TreeNode({
                                    id: currentPath,
                                    name: currentPathSplit,
                                    isLeaf: true,
                                    content: file.content,
                                })
                            );
                        }
                    }
                });
            });
            // console.log("re-create tree done");
            return rootTree;
        },
        handleCodeChanged(tabId, content) {
            let tab = this.editorTabs.find((e) => e.id == tabId);
            tab.content = content;
            tab.hasEdited = true;

            this.$emit("codeChangedNotSave", true);
        },
        saveCode(tabId) {
            let tab = this.editorTabs.find((e) => e.id == tabId);
            let file = this.value.find((e) => e.path == tabId);
            file.content = tab.content;
            tab.hasEdited = false;

            this.$Notice.success({
                title: this.$t("global.success"),
                desc: `Save file: ${tab.name}`,
            });

            this.$emit("input", this.value);
            this.$emit("afterCodeSaved", file);

            this.$emit("codeChangedNotSave", false);
        },
        onDel(node) {
            this.$Modal.confirm({
                title: "Confirm delete: " + node.name,
                okText: this.$i18n.t("rcmtable.confirmText"),
                cancelText: this.$i18n.t("rcmtable.cancelText"),
                onOk: () => {
                    node.remove();
                    // let newValue = this.value.filter((e) => e.path !== node.id);
                    let id = node.id;
                    if (!node.content) {
                        id += "/";
                    }
                    let newValue = this.value.filter((e) => e.path.indexOf(id) != 0);
                    this.$emit("input", newValue);

                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `delete : ${node.name}`,
                    });
                },
            });
        },
        onChangeName(node) {
            // console.log(node.eventType);
            if (node.eventType == "blur") {
                let split = node.id.split("/");
                let newPath =
                    split.length == 1 ? node.newName : split.slice(0, split.length - 1).join("/") + "/" + node.newName;
                // if (split.length <= 1) {
                //     newName = node.newName;
                // }
                // 判斷是改單一檔案還是改資料夾名稱
                let file = this.value.find((e) => e.path == node.id);
                if (file) {
                    file.path = newPath;
                } else {
                    file = this.value.map((e) => (e.path = e.path.replace(node.id, newPath)));
                }
                this.$emit("input", this.value);
                let tab = this.editorTabs.find((tab) => tab.id == node.id);
                if (tab) {
                    tab.name = node.newName;
                    tab.id = newPath;
                }
                if (this.focusTabId == node.id) {
                    this.focusTabId = newPath;
                }
                this.$Notice.success({
                    title: this.$t("global.success"),
                    desc: `Change New: ${node.newName}`,
                });
            }
        },
        onAddNode(node) {
            // console.log(node);
            // console.log(this.$refs.tree.model);
            if (this.formData.minioCodeEditer.length >= this.maxFileQty) {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `Quota exceeded`,
                });
                node.remove();
                return false;
            }

            if (node.isLeaf) {
                node.name = "new_file";
                node.content = "";
            } else {
                node.name = "new_folder";
            }
            while (node.parent.children.filter((e) => e.name == node.name).length > 1) {
                node.changeName(node.name + "_1");
            }

            node.id = node.pid + "/" + node.name;

            let file = { path: node.id };
            if (node.isLeaf) file.content = "";

            let newValue = [...this.value, file];
            this.$emit("input", newValue);

            this.$Notice.success({
                title: this.$t("global.success"),
                desc: `Add ${node.name}`,
            });
        },
        onClickTreeNode(node) {
            node.isSelected = true;
            if (node.isLeaf) {
                let tab = this.editorTabs.find((e) => e.id == node.id);
                // tab不存在開啟
                let { id, name, content } = node;
                if (!tab) this.editorTabs.push({ id, name, content });
                // tab存在focus
                this.focusTabId = node.id;
            }
            // this.$emit("setSelectFileData", { path: node.id, content: node.content });
        },
        beforeTabRemove(tabIndex) {
            // console.log(tabIndex);
            let tab = this.editorTabs[tabIndex];
            if (!tab.hasEdited) {
                return;
            }
            // iview 全局 modal 提示的 cancel, ok 無法隱藏, 暫解就是..不能隱藏就使用他們吧
            var self = this;
            return new Promise(function (resolve, reject) {
                self.$Modal.confirm({
                    title: "Change not save: " + tab.name,
                    footerHide: true,
                    // content: "Save before you close?",
                    okText: "Yes, save for me",
                    cancelText: "Cancel",
                    closable: true,
                    onOk: () => {
                        console.log("save before close");
                        self.saveCode(tab.id);
                        resolve();
                        // this.editorTabs = this.editorTabs.filter((tab) => tab.id !== id);
                    },
                    onCancel: () => {
                        console.log("cancel");
                        reject();
                    },
                    render: (h) => {
                        return h("div", [
                            h("h3", "Save before you close?"),
                            h(
                                "Button",
                                {
                                    on: {
                                        click: () => {
                                            console.log("close wihtout save");
                                            self.$Modal.remove();
                                            resolve();
                                        },
                                    },
                                },
                                "Close wihtout saving"
                            ),
                        ]);
                    },
                });
            });
        },
        handleTabRemove(id) {
            this.editorTabs = this.editorTabs.filter((tab) => tab.id !== id);
        },
        onClickTabs(name) {
            let data = this.value.find((e) => e.path == name);
            // this.$emit("setSelectFileData", data);
        },
        resetUploadStatus() {
            this.preUploadFiles = [];
            this.uploadFilesCount = 0;
        },
    },
    created() {
        bus.$on("selectExample", (scroll) => {
            // console.log("receive bus selectExample event");
            let files = scroll.minioCodeEditer;
            // let files = await Promise.all(this.preUploadFiles.map((file) => this.readFile(file)));
            this.$emit("input", files);
            // this.resetUploadStatus();
            var self = this;
            this.$nextTick(() => {
                self.editorDefaultOpenFile();
                // console.log(self.$refs.tree);
                self.$refs.tree.$children[0].toggle();
            });
            // scroll.minioCodeEditer.forEach((file) => {
            //     this.beforeUpload(file);
            // });
        });
    },
    beforeDestroy() {
        bus.$off("selectExample");
    },
    computed: {
        uploadPercent() {
            return Math.floor((this.uploadFilesCount * 100) / this.preUploadFiles.length);
        },
        spinShow() {
            return this.uploadFilesCount < this.preUploadFiles.length;
        },
        autoCompleteList() {
            // 現有的檔案列表 + 當前編輯器(未儲存)內容
            let currentContent = this.value
                .filter((e) => !["modules", "dist"].includes(e.path))
                .map((e) => e.content)
                .filter((e) => e);
            let editorBufferContent = this.editorTabs.map((e) => e.content).filter((e) => e);

            let list = [...currentContent, ...editorBufferContent]
                .map((e) => e.split(/[^A-Za-z]/))
                .flat()
                .filter((e) => /\w/.test(e))
                .slice(0, 20);
            return [...new Set(list)];
        },
    },
    watch: {
        value: {
            handler: function (val, oldVal) {
                this.updateDirectoryTree();

                // let findOldVal = oldVal.find((oldE) => val.find((e) => oldE.path == e.path));
                // // 監視有引用範本將編輯器關掉
                // if (!findOldVal) {
                //     this.editorTabs = [];
                // } else {
                //     // 如果名稱有異動也要關閉
                //     let findEditorTab = this.editorTabs.find((item) => {
                //         let findNewVal = val.find((e) => item.id == e.path);
                //         if (findNewVal) {
                //             return item;
                //         }
                //     });
                //     if (!findEditorTab) {
                //         this.editorTabs = [];
                //     }
                // }
            },
            deep: true,
        },
    },
    filters: {
        pretty: function (value) {
            return JSON.stringify(JSON.parse(value), null, 2);
        },
    },
};
</script>

<style scoped>
/*頂部工具列*/
#CodeEditorV3 >>> .editor-header {
    height: 24px;
}
/*頂部工具列*/
#CodeEditorV3 >>> .editor-header-toolbox {
    background-color: darkcyan;
}
#CodeEditorV3 >>> .editor-header-toolbox > .ivu-btn {
    border-radius: 0px;
}

/*樹型結構高寬*/
#CodeEditorV3 >>> .ivu-layout-sider {
    min-height: 100vh;
    width: 200px;
    min-width: 200px;
    max-width: unset;
    flex: 0 0 auto;
}
/*樹型結構填充*/
#CodeEditorV3 >>> .ivu-layout-sider-children > .vtl {
    padding: 5px 15px;
}
/*
.vtl-node-main {
    padding: 2px 2px 2px 2px;
}
*/
/*樹型結構高亮*/
#CodeEditorV3 >>> .vtl-node-main:hover {
    background-color: none;
    color: gray;
}
/*樹型結構擴展收合符號*/
#CodeEditorV3 >>> .vtl-icon-caret-down::before {
    content: " — " !important;
}
#CodeEditorV3 >>> .vtl-icon-caret-right::before {
    content: "＋";
}

/*頁籤顏色*/
#CodeEditorV3 >>> .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    background: #2a2a2e;
    color: white;
}
#CodeEditorV3 >>> .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
    background: gray;
    color: wheat;
}
#CodeEditorV3 >>> .ivu-tabs-bar {
    border-bottom: 1px solid #dcdee2;
    margin-bottom: 0px;
}

/*編輯區域背景色*/
#CodeEditorV3 >>> .ivu-layout-content {
    /* background: darkslategray */
    background: #2a2a2e;
}
/*編輯區域自適應高度*/
#CodeEditorV3 >>> .CodeMirror-scroll {
    max-height: 100vh;
}
#CodeEditorV3 >>> .CodeMirror {
    height: auto !important;
}

#CodeEditorV3 >>> .vtl-selected {
    /* background: darkseagreen; */
    background: cadetblue;
}

/*編輯區域行高*/
#CodeEditorV3 {
    line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/CodeEditorV3.vue